import Vue from 'vue'

import HpSlider from './hp-swiper'
import MailModule from './mail-module'
import HpMenu from './hp-menu'
import FormationList from './formation-list'
import ConseilsFilters from './conseils-filters'
import DockFilters from './dock-filters'

import CustomSelect from './CustomSelect'

// Renderless
import HpTransitions from './hp-transition'
import Accordion from './accordion'
import ConfirmationContact from './confirmation-contact'
import SingleFormationScript from './single-formation-scripts'
import InfiniteScroll from './infinite-scroll'

Vue.component('hp-slider', HpSlider)
Vue.component('mail-module', MailModule)
Vue.component('hp-transitions', HpTransitions)
Vue.component('hp-menu', HpMenu)
Vue.component('accordion', Accordion)
Vue.component('formation-list', FormationList)
Vue.component('conseils-filters', ConseilsFilters)
Vue.component('confirmation-contact', ConfirmationContact)
Vue.component('single-formation-scripts', SingleFormationScript)
Vue.component('dock-filters', DockFilters)
Vue.component('infinite-scroll', InfiniteScroll)


Vue.component('custom-select', CustomSelect)
